import {SortingOrderEnum} from 'enums';
import {IProgramsMasterInstrumentsSortOrder} from 'models';
import {ProgramMasterInstrumentsDropdownNameEnum, ProgramsMasterInstrumentsOrderingEnum} from '../enums';

export const getProgramMasterInstrumentsMenuItemsList = (
  itemClickHandler: () => void,
  handleItemClick: (handleItemSortObj: IProgramsMasterInstrumentsSortOrder) => void
) => {
  const onClick = (
    itemClickHandler: () => void,
    handleItemClick: (handleItemSortObj: IProgramsMasterInstrumentsSortOrder) => void,
    handleItemSortObj: IProgramsMasterInstrumentsSortOrder
  ) => {
    return () => {
      itemClickHandler();
      handleItemClick(handleItemSortObj);
    };
  };

  return [
    {
      name: ProgramMasterInstrumentsDropdownNameEnum.Name_ASC,
      clickHandler: onClick(itemClickHandler, handleItemClick, {
        order: ProgramsMasterInstrumentsOrderingEnum.Name,
        sort: SortingOrderEnum.ASC,
      }),
    },
    {
      name: ProgramMasterInstrumentsDropdownNameEnum.Name_DESC,
      clickHandler: onClick(itemClickHandler, handleItemClick, {
        order: ProgramsMasterInstrumentsOrderingEnum.Name,
        sort: SortingOrderEnum.DESC,
      }),
    },
    {
      name: ProgramMasterInstrumentsDropdownNameEnum.Type_PRE_POST,
      clickHandler: onClick(itemClickHandler, handleItemClick, {
        order: ProgramsMasterInstrumentsOrderingEnum.Type,
        sort: SortingOrderEnum.ASC,
      }),
    },
    {
      name: ProgramMasterInstrumentsDropdownNameEnum.Type_POST_PRE,
      clickHandler: onClick(itemClickHandler, handleItemClick, {
        order: ProgramsMasterInstrumentsOrderingEnum.Type,
        sort: SortingOrderEnum.DESC,
      }),
    },
  ];
};
